import { type ReactElement, useEffect, useState } from 'react';
import styled from 'styled-components';

const Bar = styled.div`
  position: sticky;
  top: 0;
  z-index: ${({ theme }) => theme.zIndex.header};
  width: 100%;
  box-sizing: border-box;
  padding: ${({ theme }) => theme.space[1]}px ${({ theme }) => theme.layout.pagePaddingMobile}px;
  background: ${({ theme }) => theme.colors.warning.light};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: ${({ theme }) => theme.fontSizes[5]}px;
  line-height: 1.35;
  text-align: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.divider};
`;

/**
 * Показывает заметное сообщение при потере сети (без имитации успешных ответов API).
 */
function NetworkOfflineBanner(): ReactElement | null {
  const [online, setOnline] = useState(() =>
    typeof navigator !== 'undefined' ? navigator.onLine : true,
  );

  useEffect(() => {
    const onOnline = (): void => setOnline(true);
    const onOffline = (): void => setOnline(false);
    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);

    return () => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }, []);

  if (online) {
    return null;
  }

  return (
    <Bar role="status" aria-live="polite">
      Нет подключения к сети. Данные могут быть недоступны. Проверьте интернет и обновите страницу.
    </Bar>
  );
}

export { NetworkOfflineBanner };
